module.exports = __webpack_public_path__ + "static/img/tk.1959d9de.svg";